import { getBaseUrl, sendRequest } from "../helpers/apiHelper";

export const getReceiveSummeryReport = async (days: number = 7, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/ReceiveSummeryReportList?days=${days}`, 'get', null, null, abortSignal);
};

export const getSellSummeryReport = async (days: number = 7, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SellSummeryReportList?days=${days}`, 'get', null, null, abortSignal);
};

export const getSellServiceSummeryReport = async (days: number = 7, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SellServiceSummeryReportList?days=${days}`, 'get', null, null, abortSignal);
};

export const getSellServiceItemSummeryReport = async (days: number = 7, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SellServiceItemSummeryReportList?days=${days}`, 'get', null, null, abortSignal);
};

export const getTopSellingDay = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/TopSellingDay?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateSellsAmount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateSellsAmount?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateReceivesAmount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateReceivesAmount?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateCreatedReceiptsCount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateCreatedReceiptsCount?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateDeliveredReceiptsCount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateDeliveredReceiptsCount?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateCreatedServicesCount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateCreatedServicesCount?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateReadyServicesCount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateReadyServicesCount?currentDate=${date}`, 'get', null, null, abortSignal);
};

export const getSpecificDateDeliveredServicesCount = async (date: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/Reports/SpecificDateDeliveredServicesCount?currentDate=${date}`, 'get', null, null, abortSignal);
};
